import { BRAND_FEATURES, BRANDES, hasBrandFeature, ORGANIZE_ADDITIONAL, PARTICIPANT_DATA_ADDITIONAL, CONTRACT_STATUS, getUserBrandCode } from '@/constants/organisation';

export default {
  data() {
    return {
      BRAND_FEATURES, BRANDES, ORGANIZE_ADDITIONAL, PARTICIPANT_DATA_ADDITIONAL, CONTRACT_STATUS
    };
  },
  computed: {
    me() {
      return this.$store.getters['user/me'];
    },
    userBrandCode() {
      return getUserBrandCode(this.me);
    },
  },
  methods: {
    getUserBrandCode,
    /**
     * Checks if current user (this.me) or provided brand code has access to feature
     * @param {string[]|string} feature - BRAND_FEATURES.PRICE_CALCULATIONS
     * @param {string|null} [targetBrand=null] - Optional brand code (e.g. row.brand_code). If omitted/null, uses this.me?.organisation?.[0]?.brand_code
     */
    hasBrandFeature(feature, targetBrand = null) {
      const brandCode = targetBrand || this.userBrandCode;
      return hasBrandFeature(feature, brandCode);
    },
  },
};

